package com.fireavert.events.active_events.data_models

enum class ActiveSensorType {
    Smoke,
    Water,
    Tamper,
    Offline,
    Shutoff,
}